import { useEffect, useState } from "react";

import apiClient from "../services/apiClient";

// 계정 메뉴의 '텔레그램 알림'(2026-09-30). 연결을 누르면 @ginecho_bot 이 열리고, 거기서 '시작' 을
// 누르면 이 계정에 이어진다. 출제·학습 완료·레벨테스트를 알려 주고, 방마다 '레벨테스트만' 을 고를 수 있다.
// 서버: api/echo/teacher_telegram.py

// 연결 주소를 받아 텔레그램을 연다. 팝업 차단을 피하려고 창을 먼저 열고 주소를 나중에 넣는다.
// 첫 화면 팝업(TelegramPromptModal)도 이것을 쓴다.
export const openTelegramConnect = async () => {
  const opened = window.open("", "_blank");
  try {
    const response = await apiClient.post("/api/v1/echo/teacher/telegram", { action: "connect" }, { withAuth: true });
    if (opened) opened.location.href = response.data.url;
    else window.location.href = response.data.url;
    return "";
  } catch (caught) {
    if (opened) opened.close();
    return caught.response?.data?.error || "연결 주소를 만들지 못했어요.";
  }
};

const TelegramConnect = () => {
  const [data, setData] = useState(null);
  const [message, setMessage] = useState("");

  const load = () =>
    apiClient
      .get("/api/v1/echo/teacher/telegram", { withAuth: true })
      .then((response) => setData(response.data))
      .catch(() => setData(null));

  useEffect(() => {
    load();
  }, []);

  if (!data) return null;

  const post = (body) => apiClient.post("/api/v1/echo/teacher/telegram", body, { withAuth: true });

  const connect = async () => {
    setMessage("");
    const error = await openTelegramConnect();
    setMessage(error || "텔레그램에서 '시작' 을 누른 뒤 아래 '연결 확인' 을 눌러 주세요.");
  };

  const changeScope = async (id, scope) => {
    const response = await post({ action: "scope", id, scope });
    setData(response.data);
  };

  const disconnect = async (id) => {
    const response = await post({ action: "disconnect", id });
    setData(response.data);
  };

  const test = async () => {
    const response = await post({ action: "test" });
    setMessage(response.data.sent ? "테스트 알림을 보냈어요. 텔레그램을 확인해 주세요." : "보내지 못했어요. 연결을 다시 해 주세요.");
  };

  const chatList = data.chat_list || [];

  return (
    <div className="user-menu__telegram">
      <div className="user-menu__academy-title">텔레그램 알림</div>
      {!data.enabled ? (
        <p className="user-menu__telegram-help">준비 중이에요.</p>
      ) : (
        <>
          <p className="user-menu__telegram-help">출제 · 학습 완료 · 레벨테스트 소식을 텔레그램으로 바로 알려 드려요. 레벨테스트만 받을 수도 있어요.</p>
          {chatList.map((one) => (
            <div key={one.id} className="user-menu__telegram-row">
              <span>✅ {one.teacher_name || one.telegram_name || "연결됨"}</span>
              <select value={one.scope} onChange={(event) => changeScope(one.id, event.target.value)}>
                {Object.entries(data.scope_label || {}).map(([value, label]) => (
                  <option key={value} value={value}>{label}</option>
                ))}
              </select>
              <button type="button" onClick={() => disconnect(one.id)}>끊기</button>
            </div>
          ))}
          <div className="user-menu__telegram-actions">
            <button type="button" className="user-menu__telegram-main" onClick={connect}>
              {chatList.length ? "다른 기기 연결" : "텔레그램 연결"}
            </button>
            <button type="button" onClick={load}>연결 확인</button>
            {chatList.length > 0 && (
              <button type="button" onClick={test}>테스트 보내기</button>
            )}
          </div>
          {message && <p className="user-menu__telegram-help">{message}</p>}
        </>
      )}
    </div>
  );
};

export default TelegramConnect;
